import React, { FC, useEffect, useState } from 'react'
import { payMobx } from '@mobxStore'
import { find } from '@dt/fe-utils/dist/lodash'
import { apConfigG } from '@ctrls/third'
import AlipaySimpleItem from './SimpleItem'

interface IProps {
  method?: any;
  selected?: boolean;
  onChange?: () => void;
}

const AlipayMethodItem: FC<IProps> = ({ method, selected, onChange }) => {
  const amount = method?.amount
  useEffect(() => {
    const channelType = payMobx.methodChannelMap.alipay
    if (channelType === 'AlipayApp') {
      apConfigG.init()
    }
    return () => {
      apConfigG.remove()
    }
  }, [payMobx.methodChannelMap])

  return (
    <AlipaySimpleItem
      selected={selected} amount={amount} onChange={onChange}
    />
  )
}

export default AlipayMethodItem
